// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oeV2","label":"styles_label__31wMT"};